module.exports = {
    RECEIVE_ALL_ANTENNAS: 'RECEIVE_ALL_ANTENNAS',
    RECEIVE_ANTENNA: 'RECEIVE_ANTENNA',
    RESET_ANTENNA: 'RESET_ANTENNA',
    RECEIVE_ANTENNAS_LAST_SITUATIONS: 'RECEIVE_ANTENNAS_LAST_SITUATIONS',
    RECEIVE_ALL_ANTENNA_SITUATIONS: 'RECEIVE_ALL_ANTENNA_SITUATIONS',
    RECEIVE_ANTENNA_TYPES: 'RECEIVE_ANTENNA_TYPES',
}
